import { Option } from '@app/components/various/Fields/Select';
import { AutocompleteField } from '@app/components/various/Form';
import { getCurrencyAffix } from '@app/logic/price';
import { usePricelists } from '@app/services/hooks/pricelists/usePricelists';
import { Lookbook } from '@typings';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const PricelistFormOption = () => {
  const { t } = useTranslation(['common']);
  const { data: pricelists = [], isPending: isLoadingPricelists } = usePricelists();
  const hasPricelists = useWatch<Lookbook.CreateLookbookForm, 'pricelists'>({ name: 'pricelists' }).length > 0;

  return (
    <AutocompleteField
      name="pricelists"
      overflowContainer
      isLoadingOptions={isLoadingPricelists}
      label={t('common:pricelist')}
      placeholder={hasPricelists ? '' : t('common:none')}
    >
      {pricelists.map(({ id, name, currency }) => (
        <Option key={id} value={id} description={getCurrencyAffix(currency)}>
          {name}
        </Option>
      ))}
    </AutocompleteField>
  );
};
